import { initI18n } from '@enechain/eposition-i18n'

import enPage from '~/i18n/locales/en/page.json'
import jaPage from '~/i18n/locales/ja/page.json'

export default initI18n({
  resources: {
    en: {
      page: enPage,
    },
    ja: {
      page: jaPage,
    },
  },
})
